import request from "root/js/request";

export const getAnalyticsProductsSearch = async ({
  cabinet_id__in,
  product_id,
  imt_id,
  size_id,
  date_from,
  date_to,
  period,
  brand_id__in,
  category_id__in,
  subject_id__in,
  ...rest
}) => {
  const response = await request({
    url: "/analytics/products_search/",
    method: "get",
    params: {
      cabinet_id__in,
      product_id,
      imt_id,
      size_id,
      date_from: date_from || undefined,
      date_to: date_to || undefined,
      period,
      brand_id__in,
      category_id__in,
      subject_id__in,
      ...rest,
    },
  });
  return response.data;
};
